import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { RailsViewActions } from '../components/discovery/rails_view_store';
import isNode from '@reverbdotcom/commons/src/is-node';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

const RecentlyViewedRoute = (
  <Route
    key="browsing_history"
    path="browsing_history"
    props={{
      pageViewEvent: {
        pageName: MParticlePageName.RecentlyViewed,
      },
    }}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'feed' */
        '../components/discovery/feed/rails_view'
      ).then(m => cb(null, m.default));
    }}
    onChange={(_, nextState) => {
      RailsViewActions.fetchHTML('/browsing_history', nextState.location.query);
    }}
    onEnter={(nextState) => {
      if (isNode) { return; }

      RailsViewActions.fetchHTML('/browsing_history', nextState.location.query);
    }}
    onLeave={() => {
      RailsViewActions.clearHTML();
    }}
  />
);

export default RecentlyViewedRoute;
